import api from '..'

const requests = {
    fetchCoupons: async ({ search, sortKey, sortType, pageSize, pageNo }) => {
        try {
            var response = await api.get(`/wellful/Coupon/`, {
                params: {
                    search,
                    sortKey,
                    sortType,
                    pageSize,
                    pageNo
                }
            })

            return response.data
        } catch (error) {
            throw error.response ? error.response.status : error
        }
    },
    fetchCoupon: async (id) => {
        try {
            var response = await api.get(`/wellful/Coupon/${id}`)
            return response.data
        } catch (error) {
            throw error.response ? error.response.status : error
        }
    },
    createCoupon: async (payload) => {
        try {
            var response = await api.post(`/wellful/Coupon`, payload)

            return response.data
        } catch (error) {
            throw error.response ? error.response.status : error
        }
    },
    updateCoupon: async (payload) => {
        try {
            var response = await api.put(`/wellful/Coupon/${payload.id}`, payload)
            return response.data
        } catch (error) {
            throw error.response ? error.response.status : error
        }
    },

    redeemCoupon: async (payload) => {
        try {
            var response = await api.post(`/wellful/Coupon/Redeem`, payload)
            return response.data
        } catch (error) {
            throw error.response ? error.response : error
        }
    },

    fetchCouponSummary: async (search) => {
        // try {
        //     var response = await api.get(`/data/getCRMcontactsSummary.php`, {
        //         params: {
        //             custID,
        //             bdm,
        //             search
        //         }
        //     })
        //     return response.data
        // } catch (error) {
        //     throw error.response ? error.response.status : error
        // }
        return null
    }
}

export default requests
